import { LocalResolver } from '@angular/compiler/src/compiler_util/expression_converter';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { ExportPayload, TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-talent-insights-ai',
  templateUrl: './talent-insights-ai.component.html',
  styleUrls: ['./talent-insights-ai.component.scss']
})
export class TalentInsightsAiComponent implements OnInit {

  companyname: any;
  @Input() requestaidata;
  @Input() insightstabname;
  aidata: any
  filterdata: any;
  locationsfilterdata: any = [];
  skillsfilterdata: any =[];
  functionsfilterdata: any = [];
  aifilter: any
  showshimmerloader: boolean = false;
  aisubscription: Subscription;
  @Input() totalcount;
  subscriptions: Subscription[] = [];
  successMessage: string = '';
  errorMessage: string = '';
  /**
   * Normalized tab-names for insights-export API payload
   */
  normalizedTabNamesForInsightsExport: any = { 'overview': 'overview', 'location': 'location', 'company': 'company', 'education': 'education', 'skills': 'skills', 'industries': 'industries', 'titles': 'titles', 'profiles': 'profile', 'diversity': 'diversity' };

  constructor(private router: Router, private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsService: TalentInsightsService) { }

  ngOnInit() {
    this.personsearchservice.getTalentinsightsFilterAI.subscribe((response)=>{
      this.filterdata = response;
      this.getfilterdata();
    })
    this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.getfilterdata());
    
    // subscribe to insights-export subject for receiving data from tab-level component
    const insightsExportSubscription = this.talentInsightsService.insightsExportDataEvent.subscribe((payloadData: ExportPayload) => {
      this.exportToPDF(payloadData);
    });
    this.subscriptions.push(insightsExportSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  generateai() {
    this.showshimmerloader = true
    this.aidata = '';
    const payload = {
      insightstabname: this.insightstabname,
      data: this.requestaidata,
      filters: this.aifilter
    }
    this.aisubscription = this.personsearchservice.gettalentinsightssummary(payload).subscribe((res:any)=>{
      this.aidata = res.data;
      this.showshimmerloader = false
      this.aidata = this.aidata.replace(/(?:\r\n|\r|\n)/g, '<br>')
    })
  }

  getfilterdata() {
    this.filterdata = this.filterDataHandlerService.fetchFilterData;
    if(this.filterdata) {
      this.aifilter = {
        locations:  this.filterdata && this.filterdata.locationSelectedList.length ? this.filterdata.locationSelectedList.filter(l => l.isExcluded == false).map(l => l.key):[],
        functions: this.filterdata && this.filterdata.functionSelectedList ? this.filterdata.functionSelectedList.map(l => l.key):[],
        preferredskills: this.filterdata && this.filterdata.skillsSelectedList.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == false).map(s => s.key):[],
        mandatoryskills: this.filterdata && this.filterdata.skillsSelectedList.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == true).map(s => s.key):[],
        jobtitles: this.filterdata && this.filterdata.jobTitleSelectedList.length ? _.uniq(this.filterdata.jobTitleSelectedList.filter(jobTitle => jobTitle.isExcluded == false).map(j => j.key)):[],
        companies: this.filterdata && this.filterdata.companySelectedList.length ? this.filterdata.companySelectedList.filter(company => company.isExcluded == false).map(j => j.key): [],
        industries: this.filterdata && this.filterdata.industrySelectedList.length ? this.filterdata.industrySelectedList.map(industry => industry.key): [],
        fromyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceFrom ? [this.filterdata.yearsofexperienceFrom]: [],
        toyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceTo ? [this.filterdata.yearsofexperienceTo]: [],   
        schools: this.filterdata && this.filterdata.schoolSelectedList.length ?this.filterdata.schoolSelectedList.map(s => s.key): [] ,
        degrees:  this.filterdata && this.filterdata.educationSelectedList.length ?  this.filterdata.educationSelectedList.map(e => e.key): [],
        keywords:  this.filterdata && this.filterdata.keywordSelectedList.length ? this.filterdata.keywordSelectedList: [],
        genders: this.filterdata && this.filterdata.gender ? [this.filterdata.gender]: [],
        currentfromyearsofexperiences: this.filterdata && this.filterdata.currentfromyearsofexperience ? [this.filterdata.currentfromyearsofexperience]: [],
        currenttoyearsofexperiences: this.filterdata && this.filterdata.currenttoyearsofexperiences ? [this.filterdata.currenttoyearsofexperiences]: [],
        seniorities: this.filterdata && this.filterdata.seniority.length ? this.filterdata.seniority: [],
        companysizes: this.filterdata && this.filterdata.companysize.length ? this.filterdata.companysize: []
      }
      this.aidata = '';
      this.showshimmerloader = false;
      if(this.aisubscription)
      this.aisubscription.unsubscribe();
    //  if(this.filterdata.filterselected == 'yes') {
    //   this.generateai();
    //  }
     
   // }
  }
}

  /**
   * Request insights export from currently active tab
   */
  requestInsightsExport() {
    const currentlyActiveTab = this.router.url.split('/').pop().split('report-').pop();
    this.talentInsightsService.sendInsightsExportRequest({ type: 'SIGNAL', action: '', data: { currentTab: currentlyActiveTab } });
  }

  /**
   * Initiate insights export using received payload
   * @param payloadData 
   */
  exportToPDF(payloadData: ExportPayload) {
    const currentlyActiveTab = this.router.url.split('/').pop().split('report-').pop();
    const filtersData = this.filterDataHandlerService.fetchFilterData;
    // remove "searchastext" from filter data & perform basic transformations
    Object.entries(filtersData).forEach(([key, value]) => {
      if(value && Array.isArray(value)) {
        filtersData[key] = (Array.isArray(value) ? value : [value]).filter(Boolean).map(s => typeof s === 'string' ? s.split('.searchastext')[0] : s.key.split('.searchastext')[0]);
      }
    });
    
    const payloadForExport: ExportPayload = {
      tab: this.normalizedTabNamesForInsightsExport[currentlyActiveTab], 
      data: { 
        ...payloadData, 
        filters: filtersData 
      }
    };
    if(this.aidata) {
      payloadForExport.data['aiData'] = this.aidata;
    } else {
      this.getfilterdata();
      payloadForExport.data['aiData'] = null;
      payloadForExport.data['aiRequestFilters'] = this.aifilter;
      payloadForExport.data['aiRequestPayload'] = this.requestaidata;
    }
    payloadForExport.data['aiInsightsTabName'] = this.insightstabname;
    
    // service call
    this.talentInsightsService.exportInsightsToPDFReport(payloadForExport).subscribe((res: any) => {
      if(res) {
        if(res.status === 'failure') {
          this.errorMessage = 'Error occured while generating the report';
        } else {
          this.successMessage = 'You will receive the talent insights report on your email in a min.';
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      } else {
        this.errorMessage = 'Error occured while generating the report';
      }
    }, () => {
      this.errorMessage = 'Error occured while generating the report';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  }

}
